<h2 mat-dialog-title [ngClass]="'tt-secondary-background'" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle>
    {{ data.tile_heading_text }}
</h2>
<mat-dialog-content class="flex-1">
    <ag-charts-angular *ngIf="graphoption" style="width: 100%; height: 30rem" [options]="graphoption"></ag-charts-angular>

    <!-- <p [ngStyle]="style['message']">{{ translations["message"] }}</p> -->
</mat-dialog-content>
<!-- <mat-dialog-actions align="end"></mat-dialog-actions> -->
